import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';

import { PlainToolbarComponent } from './plain-toolbar/plain-toolbar.component';

@NgModule({
  declarations: [PlainToolbarComponent],
  imports: [CommonModule, SharedModule],
  exports: [PlainToolbarComponent],
})
export class PlainToolbarModule {}
